// Colocated strings for ItemsGridPaginatedReportsDialog (SKILL.md rule 11, PACKAGING_PLAN §3.2).
// Consumed by ../setup.js as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a LOCAL
// composer with the warn flags off: these keys resolve here and never touch the app's bundle.
//
// Lifted verbatim from the app's `src/locales.js` (same names, top level) when the component
// moved into @rdrive/ui (2026-09-30). All twelve exist in all 10 bundles there.
// `groupBy` / `orderBy` (IA_ABSORPTION_PLAN 13.4, the opt-in Grid-mode selects) are issue-analysis's
// labels as it rendered them: its dialog called t('Group by') / t('Order by'), keys no bundle had,
// so every locale showed the key itself — English in the first 10 here (translation debt); `vi`
// (the 11th locale, 2026-10-28) shipped them translated.
//
// Not translated, and not keys: the file-format and page-size option titles in setup.js
// ('PDF', 'Word', 'Excel', …, 'A4', 'A3') are literals, as they were before the move.
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
